import React from 'react';

import ActionButton, { IActionButtonProps } from 'components/action-button';
import { ModalContent as OriginalModalContent } from 'components/modal';
import { primitive } from 'styles/constants';

import { ADDRESS_MODAL_WIDTH_DESKTOP } from './constants';

type DeliverHereButtonProps = Omit<IActionButtonProps, 'children'> & {
  children?: React.ReactNode;
};

export const ModalContent = OriginalModalContent.withConfig({
  width: { base: 'full', md: ADDRESS_MODAL_WIDTH_DESKTOP },
  paddingX: { base: '$3', md: '$0' },
  alignSelf: 'center',
});

export const DeliverHereButton = (props: DeliverHereButtonProps) =>
  React.createElement(ActionButton, {
    fullWidth: true,
    borderWidth: 0,
    color: primitive.$white,
    mb: '$4',
    _disabled: {
      bg: primitive.$fieryRedOpacity30,
      color: primitive.$white,
      opacity: 1,
      borderWidth: 0,
    },
    _text: {
      fontSize: 'lg',
      color: primitive.$white,
    },
    _loading: {
      bg: primitive.$fieryRedOpacity30,
      borderWidth: 0,
      borderColor: primitive.$bbqBrown,
    },
    ...props,
  });
